import Glider from 'react-glider';
import 'glider-js/glider.min.css';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { GradientIcon } from './gradients/GradientIcon';
import { GliderMethods } from 'react-glider/dist/types';
import { RefObject } from 'react';
import { SxProps, useTheme } from '@mui/material/styles';
import styled from 'styled-components';

export type ReactGliderProps = {
  itemWidth: number;
  hasArrows: boolean;
  navGradientColor?: string;
  children?: JSX.Element | JSX.Element[];
  gliderRef?: RefObject<GliderMethods>;
  sxIconLeft?: SxProps & object;
  sxIconRight?: SxProps & object;
  formatContainer?: boolean;
  trackStyle?: React.CSSProperties;
};

const StyledGlider = styled(Glider)<ReactGliderProps>`
  & .glider-track {
    ${(props) => {
      return props.trackStyle;
    }}
  }
`;

export function ReactGlider(props: ReactGliderProps) {
  const {
    gliderRef,
    children,
    itemWidth,
    hasArrows,
    navGradientColor,
    sxIconLeft,
    sxIconRight,
    formatContainer = false,
    trackStyle,
  } = props;
  const theme = useTheme();

  const iconLeft = navGradientColor ? (
    <GradientIcon
      IconComponent={ArrowBackIosRoundedIcon}
      gradientColor={navGradientColor}
      sx={{
        width: '50px',
        height: '50px',
        filter: `drop-shadow(${theme.shadowsHard.primaryElevation2})`,
        ...sxIconLeft,
      }}
    />
  ) : (
    <ArrowBackIosRoundedIcon fontSize={'large'} />
  );
  const iconRight = navGradientColor ? (
    <GradientIcon
      IconComponent={ArrowForwardIosRoundedIcon}
      gradientColor={navGradientColor}
      sx={{
        width: '50px',
        height: '50px',
        filter: `drop-shadow(${theme.shadowsHard.primaryElevation2})`,
        ...sxIconRight,
      }}
    />
  ) : (
    <ArrowForwardIosRoundedIcon fontSize={'large'} />
  );

  return (
    <StyledGlider
      ref={gliderRef}
      className={formatContainer ? 'glider-container' : undefined}
      slidesToShow="auto"
      slidesToScroll={1}
      itemWidth={itemWidth}
      draggable={true}
      hasArrows={hasArrows}
      rewind={true}
      duration={1}
      scrollLock={false}
      dragVelocity={1.5}
      iconLeft={iconLeft}
      iconRight={iconRight}
      trackStyle={trackStyle}
    >
      {children}
    </StyledGlider>
  );
}
